import { Flex } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";

interface ContentItemProps {
  titulo: string;
  descricao?: string | number;
  tituloIcon?: React.ReactNode;
  descricaoContent?: React.ReactNode;
  fontSizeTitulo?: string;
  fontSizeDescricao?: string;
  fontWeightTitle?: string;
  fontWeightDescricao?: string;
  colorTitulo?: string;
  colorDescricao?: string;
}

export default function ContentItem({
  titulo,
  descricao,
  tituloIcon,
  descricaoContent,
  fontSizeTitulo = "14px",
  fontSizeDescricao = "16px",
  fontWeightDescricao = "normal",
  fontWeightTitle = "normal",
  colorTitulo = "#768398",
  colorDescricao,
}: ContentItemProps) {
  return (
    <Flex direction="column" mb="3">
      <Flex gap={2}>
        <Text color={colorTitulo} fontSize={fontSizeTitulo} fontWeight={fontWeightTitle}>
          {titulo}
        </Text>
        {tituloIcon}
      </Flex>
      <Flex
        fontSize={fontSizeDescricao}
        fontWeight={fontWeightDescricao}
        color={colorDescricao}
      >
        {descricao}
      </Flex>
      <Flex>{descricaoContent}</Flex>
    </Flex>
  );
}
